import { format } from 'date-fns';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject, NothingHere } from 'Mri.Web.Common';
import * as React from 'react';
import { BsCardHeading } from '@react-icons/all-files/bs/BsCardHeading';
import { AuditStore } from '../Audit/AuditStore';

export interface IUserAuditLogProps {
    readonly user: Mri.Web.Portal.Controllers.Account.UserModel;
}

@autoinject
@observer
export class UserAuditLog extends React.Component<IUserAuditLogProps> {
    @action
    public async componentDidMount() {
        this.loading = true;

        try {
            await this.auditStore.loadAuditLog(this.props.user.id);
        } catch (e: any) {
            console.error(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid card">
                <div className="row bg-teal">
                    <div className="col">
                        Event
                    </div>
                    <div className="col">
                        Details
                    </div>
                    <div className="col">
                        Date
                    </div>
                </div>
                <div className="container-fluid" style={{maxHeight: 400 + 'px', overflowY: 'scroll' }}>
                        {this.auditLogs?.map(this.renderAuditLog)}
                    </div>
            </div>
        );
    }

    public renderAuditLog(auditLog: Mri.Audit.AuditLog<any>, key: any) {
        switch (auditLog.type) {
            case Mri.Audit.ActionType.AcceptedDocumentsTermsAndConditions:
                return (
                    <div className="row" key={key}>
                        <div className="col">
                            Accepted {auditLog.payload.title!}
                        </div>
                        <div className="col">
                            -
                        </div>
                        <div className="col">
                            {format(auditLog.timestamp, 'EEEE, MMMM do yyyy, h:mm:ss a')}
                        </div>
                    </div>
                );
            case Mri.Audit.ActionType.DownloadedDocument:
                return (
                    <div className="row" key={key}>
                        <div className="col">
                            Downloaded {auditLog.payload.filename!}
                        </div>
                        <div className="col">
                            -
                        </div>
                        <div className="col">
                            {format(auditLog.timestamp, 'EEEE, MMMM do yyyy, h:mm:ss a')}
                        </div>
                    </div>
                );
            case Mri.Audit.ActionType.WarrantyAlertLog:
                return (
                    <div className="row" key={key}>
                        <div className="col">
                            Alert Sent
                        </div>
                        <div className="col">
                            {auditLog.payload && auditLog.payload.profileGuid && auditLog.payload.profile &&
                                <a href={`https://internal.mri-inc.net/display-event-profiles/alerts/${auditLog.payload.profileGuid}`}
                                   target="_blank">
                                    {auditLog.displaySerialNumber} - {auditLog.payload.profile}
                                </a>
                            }
                            {auditLog.payload && !auditLog.payload.profileGuid && auditLog.payload.profile &&
                                <span>
                                    {auditLog.displaySerialNumber} - {auditLog.payload.profile}
                                </span>
                            }
                        </div>
                        <div className="col">
                            {format(auditLog.timestamp, 'EEEE, MMMM do yyyy, h:mm:ss a')}
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="row" key={key}>
                        <div className="col">
                            {auditLog.type}
                        </div>
                        <div className="col">
                            -
                        </div>
                        <div className="col">
                           {format(auditLog.timestamp, 'EEEE, MMMM do yyyy, h:mm:ss a')}
                        </div>
                    </div>
                );
        }
    }

    @computed
    private get auditLogs() {
        const events = this.auditStore.auditLogsByUser.get(this.props.user.id);
        return events;
    }

    @observable private loading = false;
    @inject
    private auditStore!: AuditStore;
}
